// Importing all the SVG icons from app_icons folder
import arrowDown from '../assets/images/app_icons/arrow-down.svg';
import arrowLeft from '../assets/images/app_icons/arrow-left.svg';
import arrowRight from '../assets/images/app_icons/arrow-right.svg';
import arrowUp from '../assets/images/app_icons/arrow-up.svg';
import bag from '../assets/images/app_icons/bag.svg';
import brandConcepts from '../assets/images/app_icons/brand-concepts.svg';
import camera from '../assets/images/app_icons/camera.svg';
import check from '../assets/images/app_icons/check.svg';
import checkmark from '../assets/images/app_icons/checkmark.svg';
import clientType from '../assets/images/app_icons/client-type.svg';
import cog from '../assets/images/app_icons/cog.svg';
import dollar from '../assets/images/app_icons/dollar.svg';
import dotsH from '../assets/images/app_icons/dots-h.svg';
import exportIcon from '../assets/images/app_icons/export.svg';
import eyeClosed from '../assets/images/app_icons/eye-closed.svg';
import eyeOpened from '../assets/images/app_icons/eye-opened.svg';
import folder from '../assets/images/app_icons/folder.svg';
import graphTrend from '../assets/images/app_icons/graph-trend.svg';
import graphUp from '../assets/images/app_icons/graph-up.svg';
import home from '../assets/images/app_icons/home.svg';
import horizontalDots from '../assets/images/app_icons/horizontal-dots.svg';
import inventory from '../assets/images/app_icons/inventory.svg';
import layoutSketch from '../assets/images/app_icons/layout-sketch.svg';
import locationPartners from '../assets/images/app_icons/location-partners.svg';
import logoSm from '../assets/images/app_icons/logo-sm.svg';
import logo from '../assets/images/app_icons/logo.svg';
import magniglass from '../assets/images/app_icons/magniglass.svg';
import mask from '../assets/images/app_icons/mask.svg';
import masks from '../assets/images/app_icons/masks.svg';
import netops from '../assets/images/app_icons/netops.svg';
import noResults from '../assets/images/app_icons/no-results.svg';
import pencil from '../assets/images/app_icons/pencil.svg';
import person from '../assets/images/app_icons/person.svg';
import pieChart from '../assets/images/app_icons/pie-chart.svg';
import plus from '../assets/images/app_icons/plus.svg';
import reports from '../assets/images/app_icons/reports.svg';
import sigma from '../assets/images/app_icons/sigma.svg';
import sortArrowDown from '../assets/images/app_icons/sort-arrow-down.svg';
import sortArrowUp from '../assets/images/app_icons/sort-arrow-up.svg';
import sortArrows from '../assets/images/app_icons/sort-arrows.svg';
import spinner from '../assets/images/app_icons/spinner.svg';
import store from '../assets/images/app_icons/store.svg';
import tag from '../assets/images/app_icons/tag.svg';
import tiles from '../assets/images/app_icons/tiles.svg';
import timesLg from '../assets/images/app_icons/times-lg.svg';
import times from '../assets/images/app_icons/times.svg';
import toastAlert from '../assets/images/app_icons/toast-alert.svg';
import toastError from '../assets/images/app_icons/toast-error.svg';
import toastInfo from '../assets/images/app_icons/toast-info.svg';
import toastSuccess from '../assets/images/app_icons/toast-success.svg';
import trash from '../assets/images/app_icons/trash.svg';
import twoColumns from '../assets/images/app_icons/two-columns.svg';
import verticalDots from '../assets/images/app_icons/vertical-dots.svg';

// Importing images from public_icons folder
import googleLogo from '../assets/images/public_icons/google-logo.svg';
import logoSymbol from '../assets/images/public_icons/logo-symbol.svg';
import logoText from '../assets/images/public_icons/logo-text.svg';

// Consolidating all imports into an AppIcons object
const AppIcons = {
  arrowDown,
  arrowLeft,
  arrowRight,
  arrowUp,
  bag,
  brandConcepts,
  camera,
  check,
  checkmark,
  clientType,
  cog,
  dollar,
  dotsH,
  exportIcon,
  eyeClosed,
  eyeOpened,
  folder,
  graphTrend,
  graphUp,
  home,
  horizontalDots,
  inventory,
  layoutSketch,
  locationPartners,
  logoSm,
  logo,
  magniglass,
  mask,
  masks,
  netops,
  noResults,
  pencil,
  person,
  pieChart,
  plus,
  reports,
  sigma,
  sortArrowDown,
  sortArrowUp,
  sortArrows,
  spinner,
  store,
  tag,
  tiles,
  timesLg,
  times,
  toastAlert,
  toastError,
  toastInfo,
  toastSuccess,
  trash,
  twoColumns,
  verticalDots,
  googleLogo,
  logoSymbol,
  logoText,
};

export default AppIcons;
